var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaterialsActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 0.75C0.25 0.335786 0.585786 0 1 0H3H14C15.6569 0 17 1.34315 17 3C17 4.65685 15.6569 6 14 6H19H21C21.4142 6 21.75 6.33579 21.75 6.75C21.75 7.16421 21.4142 7.5 21 7.5H19V10.5H21C21.4142 10.5 21.75 10.8358 21.75 11.25C21.75 11.6642 21.4142 12 21 12H19H14C15.6569 12 17 13.3431 17 15C17 16.6569 15.6569 18 14 18H3H1C0.585786 18 0.25 17.6642 0.25 17.25C0.25 16.8358 0.585786 16.5 1 16.5H3V13.5H1C0.585786 13.5 0.25 13.1642 0.25 12.75C0.25 12.3358 0.585786 12 1 12H3H8C6.34315 12 5 10.6569 5 9C5 7.34315 6.34315 6 8 6H3H1C0.585786 6 0.25 5.66421 0.25 5.25C0.25 4.83579 0.585786 4.5 1 4.5H3V1.5H1C0.585786 1.5 0.25 1.16421 0.25 0.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialsActive);
export default __webpack_public_path__ + "static/media/materials-active.bc8766500272a819237ec49632a3bc3b.svg";
export { ForwardRef as ReactComponent };